import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import {
  AlertTriangle, Truck, PackageX, PackageOpen, ArrowRight,
} from "lucide-react";
import { getTodayPanel } from "@/lib/delivery";

/**
 * Panou operațional "Astăzi" (Partea 5).
 * Cards click prop navigates to shipment list with a preset filter.
 */
export default function TodayPanel({ onFilter }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      getTodayPanel()
        .then((d) => { if (!cancelled) setData(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const cards = [
    {
      key: "refused_today",
      label: "Refuzuri azi",
      icon: PackageX,
      color: "bg-rose-50 border-rose-200 text-rose-700",
      num: "text-rose-800",
      filter: { status: "refused", refusedToday: true },
      tooltip: "Colete refuzate azi — sună clientul cât e cald",
    },
    {
      key: "out_for_delivery_today",
      label: "Ies în livrare azi",
      icon: Truck,
      color: "bg-sky-50 border-sky-200 text-sky-700",
      num: "text-sky-800",
      filter: { status: "out_for_delivery" },
      tooltip: "Colete la prima încercare de livrare astăzi",
    },
    {
      key: "stuck_in_transit",
      label: "Blocate în tranzit",
      icon: AlertTriangle,
      color: "bg-amber-50 border-amber-200 text-amber-700",
      num: "text-amber-800",
      filter: { stuck: true },
      tooltip: "Fără eveniment nou de 4+ zile — verifică GLS",
    },
    {
      key: "damaged_recent",
      label: "Avariate (48h)",
      icon: PackageOpen,
      color: "bg-orange-50 border-orange-200 text-orange-700",
      num: "text-orange-800",
      filter: { status: "damaged" },
      tooltip: "Colete avariate în ultimele 48h pentru dispută GLS",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="today-panel">
      {cards.map((c) => {
        const Icon = c.icon;
        const val = data?.[c.key] ?? "—";
        return (
          <Card
            key={c.key}
            className={`${c.color} border cursor-pointer transition-shadow hover:shadow-md`}
            onClick={() => onFilter?.(c.filter, c.label)}
            data-testid={`today-card-${c.key}`}
            title={c.tooltip}
          >
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-[11px] uppercase tracking-wide font-semibold opacity-80">
                    {c.label}
                  </div>
                  <div className={`text-3xl font-bold mt-1 ${c.num}`}>
                    {val}
                  </div>
                </div>
                <Icon className="h-5 w-5 opacity-70" />
              </div>
              <div className="mt-2 text-[10px] opacity-70 flex items-center gap-1">
                Vezi lista <ArrowRight className="h-3 w-3" />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
